module.exports = __webpack_public_path__ + "img/placeholder.e58c2055.jpg";